import { CanActivateFn } from '@angular/router';
import { CredentialsService } from '../services/credentials.service';
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = (route, state) => {
  const credentialsService: CredentialsService = inject(CredentialsService);
  return credentialsService.checkAuthentication();
};
